<template>
  <div class="articles-container">
    <v-card flat class="modern-card">
      <v-row justify="center" class="pa-4">
        <v-col cols="12" class="text-center mb-2">
          <h2 class="section-title">{{ sport }} Articles</h2>
        </v-col>

        <v-col cols="12" v-if="articles.length">
          <v-col
            cols="12"
            md="10"
            lg="8"
            class="mx-auto mb-4"
            v-for="article in articles"
            :key="article._id"
          >
            <v-card elevation="4" rounded="xl" class="article-card">
              <v-card-title class="article-title">
                {{ article.title }}
              </v-card-title>
              <v-card-subtitle class="article-meta">
                {{ article.createdAt | UtcToEst }}
                <span v-if="article.author"> — {{ article.author }}</span>
              </v-card-subtitle>
              <v-card-text class="article-content">
                <span v-html="sanitize(article.content)"></span>
              </v-card-text>
            </v-card>
          </v-col>
        </v-col>

        <v-col cols="12" md="10" lg="8" class="mx-auto text-center" v-else>
          <p class="grey--text">No articles published yet. Check back soon!</p>
        </v-col>

        <v-col cols="12" class="text-center" v-if="hasMore">
          <v-btn color="primary" outlined rounded @click="fetchPage(page + 1)">
            Load More
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import DOMPurify from "dompurify";

// the API scopes article reads by userId, so readers must ask for the
// publishers' articles rather than their own. Add an id here to let a new
// account's articles reach users.
const PUBLISHER_IDS = [
  "6107f818963dc87f216fa505", // Chazmule
  "60fedc56109bcffeb7010994", // Doughboys123
];

export default {
  name: "Articles",
  props: {
    sport: {
      type: String,
      default: "NBA",
    },
    sportId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      page: 1,
      hasMore: false,
    };
  },

  computed: mapState("userModule", ["articles"]),

  created() {
    this.fetchPage(1);
  },

  watch: {
    // router reuses this component across the per-sport routes
    sportId() {
      this.fetchPage(1);
    },
  },

  methods: {
    sanitize(html) {
      return DOMPurify.sanitize(html, { USE_PROFILES: { html: true } });
    },

    async fetchPage(page) {
      this.page = page;
      const res = await this.$store.dispatch("userModule/getPublishedArticles", {
        sportId: this.sportId,
        userIds: PUBLISHER_IDS,
        page,
        limit: 10,
      });
      this.hasMore = !!res?.pagination?.hasNextPage;
    },
  },
};
</script>

<style scoped>
.articles-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 16px 8px;
}

.modern-card {
  background: transparent !important;
  box-shadow: none !important;
}

.section-title {
  font-size: 2rem;
  font-weight: 700;
  color: #17408b;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.article-card {
  background: white;
  border-left: 4px solid #17408b;
}

.article-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #17408b;
  word-break: break-word;
}

.article-meta {
  font-size: 0.85rem;
}

.article-content {
  line-height: 1.7;
  font-size: 1rem;
  color: #333;
}

@media (max-width: 768px) {
  .articles-container {
    padding: 8px 4px;
  }

  .section-title {
    font-size: 1.75rem;
  }

  .article-title {
    font-size: 1.25rem;
  }
}
</style>
